import { SET_MODAL_SUCCES_ACTIVE } from '../actions/modalsuccesactive';
import { RESET_MODAL_SUCCES_ACTIVEN } from '../actions/modalsuccesactive';

const initialState = {
    isActiveModalSuccess: null,
};

function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET_MODAL_SUCCES_ACTIVE:
            return {
                ...state,
                isActiveModalSuccess: action.payload,
            };
        case RESET_MODAL_SUCCES_ACTIVEN:
            return {
                ...state,
                isActiveModalSuccess: action.payload,
            };
            default:
                return state;
        }
    }
    
export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/modalsuccesactive.js